import { InfoCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Select,
  Space,
  Tooltip,
  Typography,
} from "antd";
import PreviewTable from "../../../component/PreviewTable";

const { Title, Paragraph } = Typography;
const { Search } = Input;
const { Option } = Select;

const InvestorInformation = ({
  formData,
  updateFormData,
  handleSearch,
  searchData,
  productOptions,
  form,
  customerID,
  onFinish,
  investorTypeOptions,
  customerSelected,
  isEdit = false,
  showCustomer,
}) => {
  const isSearchDisabled = !customerID || customerID?.length < 5 ? true : false;

  const handleValuesChange = (changedValues, allValues) => {
    updateFormData(allValues);
  };

  const onSearch = () => {
    handleSearch(customerID);
  };

  const dataSections = [
    {
      name: "Customer Name",
      labelValue: searchData?.entityName || "----",
    },
    {
      name: "Customer ID",
      labelValue: searchData?.entityAccountNo || "----",
    },
    {
      name: "Customer Type",
      labelValue: searchData?.entityType || "----",
    },
    {
      name: "Customer Branch",
      labelValue: searchData?.entityBranch || "----",
    },
  ];

  const handleFinish = (_data) => {
    onFinish(_data);
  };

  return (
    <div className="form-section">
      <h2 style={{ margin: 0, fontSize: "24px" }}>Investor Information</h2>
      <p style={{ marginTop: "5px", color: "#6b7280" }}>
        Retrieve customer info
      </p>

      <Form
        form={form}
        onFinish={handleFinish}
        layout="vertical"
        initialValues={formData}
        onValuesChange={handleValuesChange}
        style={{ width: "100%" }}
      >
        <Row>
          {!isEdit && (
            <Col span={12} style={{ padding: "0px 8px" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "80% 17%",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: "Please enter customer ID",
                    },
                  ]}
                  label={
                    <div>
                      Customer ID{" "}
                      <Tooltip title="Customer ID">
                        <InfoCircleOutlined />
                      </Tooltip>
                    </div>
                  }
                  name={"customerID"}
                >
                  <Input
                    placeholder="Search by customer ID"
                    style={{ height: "44px" }}
                  />
                </Form.Item>
                <Button
                  disabled={isSearchDisabled}
                  onClick={onSearch}
                  style={{
                    border: "1px solid #EAECF0",
                    backgroundColor: !isSearchDisabled ? "#BA24D5" : "#F2F4F7",
                    color: !isSearchDisabled ? "white" : "#98A2B3",
                    marginTop: 5,
                  }}
                >
                  Search
                </Button>
              </div>
            </Col>
          )}
          {(searchData ?? showCustomer) && (
            <Col span={24} style={{ padding: "0px 8px", marginBottom: 30 }}>
              <PreviewTable data={dataSections} />
            </Col>
          )}
        </Row>

        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Investor Name
                  <Tooltip title="---">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"investorName"}
            >
              <Input
                placeholder="---"
                style={{ height: "44px" }}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Investor Type
                  <Tooltip title="The investor type">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"investorType"}
              rules={[
                {
                  required: true,
                  message: "Please select investor type",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select Investor Type"
                optionFilterProp="children"
                style={{ height: "44px" }}
                options={investorTypeOptions}
                disabled={!customerSelected}
              />
            </Form.Item>
          </Col>
        </Row>
        <Title style={{ marginInline: 0, marginBlock: 15 }} level={4}>
          Contact Details
        </Title>
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Contact Address
                  <Tooltip title="Contact Address">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"address"}
            >
              <Input
                placeholder="----"
                style={{ height: "44px" }}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  City
                  <Tooltip title="City">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"city"}
            >
              <Input
                placeholder="----"
                style={{ height: "44px" }}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Phone Number
                  <Tooltip title="Phone Number">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"phoneNumber"}
            >
              <Input
                placeholder="----"
                style={{ height: "44px" }}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Email
                  <Tooltip title="Email">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"email"}
            >
              <Input
                placeholder="----"
                style={{ height: "44px" }}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Bank Verification Number (BVN)
                  <Tooltip title="BVN">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"bvn"}
            >
              <Input
                placeholder="----"
                style={{ height: "44px" }}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Tax Identification Number (TIN)
                  <Tooltip title="TIN">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"tin"}
            >
              <Input
                placeholder="----"
                style={{ height: "44px" }}
                className="of-bold-disable-input"
                disabled
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default InvestorInformation;
